import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import ProjectListContainer from 'containers/project/clinic/ProjectListContainer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuickstartStore } from 'store/local/quickstart';
import styled from 'styled-components';

function QuickProjectList() {
  const { t } = useTranslation();

  const { selectedPatientCode } = useQuickstartStore();

  return (
    <StyledQuickProjectList data-component-name="QuickProjectList">
      <div className="quickProjectList__title">
        <CustomSpan fontColor="#000" fontSize={26} fontWeight={600}>
          <T>QUICKSTART_PROJECT_LIST</T>
        </CustomSpan>
      </div>
      <ProjectListContainer patientCode={selectedPatientCode} isHeader={false} listCount={6} />
    </StyledQuickProjectList>
  );
}

const StyledQuickProjectList = styled.div<{}>`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  .quickProjectList__title {
  }
`;

export default React.memo(QuickProjectList);
